export default "__VITE_ASSET__EFdWlZvz__"